import React, { Suspense, lazy } from 'react';

// Dynamically import App component to resolve type issues
const App = lazy(() => import('./App'));

const AppWrapper: React.FC = () => {
  return (
    <Suspense fallback={
      <div className="min-h-screen flex flex-col items-center justify-center bg-blue-100">
        <div 
          style={{
            fontFamily: "'Luckiest Guy', cursive",
            fontSize: "2.5rem",
            color: "#4f46e5",
            textShadow: "2px 2px 0 #ffffff, 4px 4px 0 rgba(0,0,0,0.2)",
            animation: "bounce 1s infinite alternate",
          }}
        >
          Loading Family Fun...
        </div>
        <style>
          {`@keyframes bounce {
            from { transform: scale(1) rotate(-3deg); }
            to { transform: scale(1.1) rotate(3deg); }
          }`}
        </style>
      </div>
    }>
      <App />
    </Suspense>
  );
};

export default AppWrapper; 